/**
 * <s-view-switch> — Flips a group of product cards between flat product lays and worn model shots.
 *
 * Clicking the child [role="switch"] toggles its aria-checked state and mirrors it onto this
 * element as data-view="model" | "product". Card markup reacts to that attribute in CSS, so
 * cards without a model shot simply keep showing their flat lay.
 */
class SViewSwitch extends HTMLElement {
  #ac;

  connectedCallback() {
    const toggle = this.querySelector('[role="switch"]');
    if (!toggle) return;
    this.#ac = new AbortController();
    this.dataset.view = toggle.getAttribute('aria-checked') === 'true' ? 'model' : 'product';
    toggle.addEventListener(
      'click',
      () => {
        const checked = toggle.getAttribute('aria-checked') !== 'true';
        toggle.setAttribute('aria-checked', String(checked));
        this.dataset.view = checked ? 'model' : 'product';
      },
      { signal: this.#ac.signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-view-switch')) {
  customElements.define('s-view-switch', SViewSwitch);
}
